var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.559 16.483c-5.456 1.838-7.254 3.885-8.584 8.983-1.33-5.098-3.128-7.145-8.583-8.983 5.455-1.839 7.253-3.886 8.583-8.984 1.33 5.098 3.128 7.145 8.584 8.984zM26.326 7.979c-3.077 1.033-4.091 2.183-4.842 5.047-.75-2.864-1.764-4.014-4.841-5.047 3.077-1.033 4.091-2.183 4.841-5.047.75 2.864 1.765 4.014 4.842 5.047zM26.726 22.868c-2.277.749-3.028 1.582-3.584 3.658-.555-2.076-1.306-2.91-3.583-3.658 2.277-.748 3.028-1.581 3.583-3.657.556 2.076 1.306 2.909 3.584 3.657z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgStars;